export default "__VITE_PUBLIC_ASSET__be4b1db5__"